import { ENTRYPOINT } from '../../../config/entrypoint';
import { API_ROUTES } from '../../../constants/api_routes';
import { CONTENT_TYPE, EXPENSE_TYPE_TAB, TOKEN_TYPE } from '../../../constants/constants';
import { REACT_ROUTES } from '../../../constants/react_routes';
import { deleteData, getData, getHeaders, postData, putData } from '../../../http/request';
import history from '../../../services/history';

export const EXPENSE_TYPE_ACTION_TYPES = {
	GET_EXPENSE_TYPES_SUCCESS: 'GET_EXPENSE_TYPES_SUCCESS',
    POST_EXPENSE_TYPE_SUCCESS: 'POST_EXPENSE_TYPE_SUCCESS',
    PUT_EXPENSE_TYPE_SUCCESS: 'PUT_EXPENSE_TYPE_SUCCESS',
    DELETE_WORKER_SUCCESS: 'DELETE_CUSTOMER_SUCCESS',
    UPDATE_EXPENSE_TYPES_PAGINATION: 'UPDATE_EXPENSE_TYPES_PAGINATION'
};

const EXPENSE_TYPES_URL = `${ENTRYPOINT}${API_ROUTES.EXPENSE_TYPES}`;

const getPaginationParams = ({ page, rowsPerPage }) => {
    return `?page=${page+1}&itemsPerPage=${rowsPerPage}&pagination=true`;
}

const getFilterParams = (params, filters = {}) => {
    const { search } = filters;
    let filterParams = params;
    if (search) {
        filterParams = `${filterParams}&search=${search}`;
    }
    return filterParams;
}

export const getExpenseTypes = (data = { page: 0, rowsPerPage: 10, filters: { } }) => {
    return async (dispatch) => {
        let params = getPaginationParams(data);
        const { filters } = data;
        params = getFilterParams(params, filters);
        const GET_EXPENSE_TYPES_URL = `${EXPENSE_TYPES_URL}${params}`;
        const response = await getData(GET_EXPENSE_TYPES_URL, getHeaders(TOKEN_TYPE.TOKEN, CONTENT_TYPE.LD_JSON));
        dispatch({ type: EXPENSE_TYPE_ACTION_TYPES.GET_EXPENSE_TYPES_SUCCESS, payload: response['hydra:member'] });
        dispatch({ type: EXPENSE_TYPE_ACTION_TYPES.UPDATE_EXPENSE_TYPES_PAGINATION, payload: { totalCount: response['hydra:totalItems'] } });
    }
}

export const getExpenseType = async (uuid) => {
    const GET_EXPENSE_TYPE_URL = `${EXPENSE_TYPES_URL}/${uuid}`;
    return await getData(GET_EXPENSE_TYPE_URL, getHeaders());
}

export const postExpenseType = (data) => {
    return async (dispatch) => {
        const response = await postData(EXPENSE_TYPES_URL, data);
        dispatch({ type: EXPENSE_TYPE_ACTION_TYPES.POST_EXPENSE_TYPE_SUCCESS, payload: response });
        return history.push(REACT_ROUTES.EXPENSE_TABS, { selectedTab: EXPENSE_TYPE_TAB });
    }
}

export const putExpenseType = (uuid, data) => {
    return async (dispatch) => {
        const PUT_WORKERS_URL = `${EXPENSE_TYPES_URL}/${uuid}`;
        const response = await putData(PUT_WORKERS_URL, data);
        dispatch({ type: EXPENSE_TYPE_ACTION_TYPES.PUT_EXPENSE_TYPE_SUCCESS, payload: response });
        history.push(REACT_ROUTES.EXPENSE_TABS, { selectedTab: EXPENSE_TYPE_TAB });
    }
}

export const deleteExpenseType = (uuid) => (
    async () => {
        const DELETE_EXPENSE_TYPE_URL = `${EXPENSE_TYPES_URL}/${uuid}`;
        await deleteData(DELETE_EXPENSE_TYPE_URL);
        // dispatch({ type: CUSTOMERS_ACTION_TYPES.DELETE_CUSTOMER_SUCCESS, payload: uuid });
    }
)

export const updateExpenseTypesPagination = ({ rowsPerPage, page = 0, filters }) => {
    return (dispatch) => {
        dispatch({ type: EXPENSE_TYPE_ACTION_TYPES.UPDATE_EXPENSE_TYPES_PAGINATION, payload: { rowsPerPage, page, filters } });
        dispatch(getExpenseTypes({ page, rowsPerPage, filters }));
    }
}

